import {months} from 'moment'
import {ValidationText} from '../constants'
import {helperNoneComma, helperGetBirthday} from '../helper'
import {validateMessage} from './validateMessage'

/**
 * バリデーションのeventを追加と削除
 * @param {object} validations バリデーションのルール
 * @param {array} status eventの追加か削除をみるフラグ
 * @param {string} category 信販か自社割賦
 * @param {string} error_header エラーの表示を項目のheader部分にも表示するかどうか
 */
export const validate = (validations, status, category, error_header = true) => {
  for (let column in validations) {
    validations[column].map((item) => {
      let rules = item['rule'].split(':'),
        rule = rules[0],
        func = 'validate_' + rule,
        action = item['action'],
        error_add = item['error_add'] || column,
        error_rule = item['error_rule'] || rule,
        message = item['message']
      rules.shift()
      const args = {
        handleEvent: handleValidate, // バリデーション関数
        column, // バリデーションもみているid名(key名)
        rule, // バリデーションのルール名
        terms: rules, // バリデーションの条件
        func: validateFunc[func], // バリデーション関数
        cate: category, // 信販か自社割賦かのフラグ
        action, // inputのtype定義
        error_add, // エラーメッセージを追加するid名
        error_header, // エラーの表示を項目のheader部分にも表示するかどうか
        error_rule, // エラーメッセージのルールの種類
        message // カスタムメッセージ
      }
      if (status) {
        // eventを追加
        // const element = document.getElementById(column) || document.getElementsByName(column).item(0);
        const element = document.getElementById(column) || document.getElementsByName(column)
        // console.log(element1,element1.length)
        const events = item['event'].split(',')
        // console.log(element);
        events.map((event) => {
          if (element.length) {
            element.forEach((ele) => {
              ele.addEventListener(event, args)
            })
          } else if (element) {
            element.addEventListener(event, args)
          }
          // element.addEventListener(event, args);
        })
      } else {
        // eventを削除
        // const element = document.getElementById(column) || document.getElementsByName(column).item(0);
        const element = document.getElementById(column) || document.getElementsByName(column)
        const events = item['event'].split(',')
        events.map((event) => {
          if (element.length) {
            element.forEach((ele) => {
              ele.addEventListener(event, args)
            })
          } else if (element) {
            element.addEventListener(event, args)
          }
          // element.removeEventListener(event, args);
        })
      }
    })
  }
}

/**
 * バリデーションの処理を動的に変える関数
 * @param {object} e DOMで発生するイベントインターフェイス
 * @param {string} column バリデーションもみているid名(key名)
 * @param {string} rule バリデーションのルール名
 * @param {array} terms バリデーションの条件
 * @param {function} func バリデーション関数
 * @param {string} cate 信販か自社割賦
 * @param {string} action inputのtype定義
 * @param {string} error_add エラーメッセージを追加するid名
 * @param {string} error_header エラーの表示を項目のheader部分にも表示するかどうか
 * @param {string} error_rule エラーメッセージのルールの種類
 */
function handleValidate(e) {
  setTimeout(() => {
    if (this.func(e.target, this.terms)) {
      setError(this.error_add, this.error_rule, this.rule, this.terms, this.action, this.error_header, this.message)
    } else {
      removeError(this.error_add, this.error_rule, this.error_header)
    }
  }, 100)
  // setTimeout(function() {
  //     if(this.func(e.target,this.terms)) {
  //         setError(this.error_add,this.rule,this.terms,this.action,this.error_header);
  //     } else {
  //         removeError(this.error_add,this.rule);
  //     }
  // }.bind(this),100);
}

/**
 * バリデーションの処理
 * @param {any} value event時のinputのvalue
 * @param {array} terms バリデーションの条件
 */
export const validateFunc = {
  /**
   * 必須処理
   * @param {object} target
   * @param {stirng} terms
   */
  validate_required(target, terms) {
    let ifTerms = ['radio', 'checkbox']
    let result
    if (ifTerms.includes(target.type)) {
      const byName = document.getElementsByName(target.name)
      let noChecked = true
      if (byName.length) {
        byName.forEach((ele) => {
          if (ele.checked) noChecked = false
        })
      }
      result = noChecked
    } else {
      result = target.value == '' || target.value == null || target.value === 'false'
    }
    return result ? true : false
  },

  /**
   * 必須処理(指定した他のフィールドかつ自分のどれか一つでも存在していなければエラー)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_without(target, terms) {
    const terms_split = terms[0].split(',')
    let required = false
    terms_split.map((id) => {
      const other_value = document.getElementById(`${id}`)
        ? document.getElementById(`${id}`).value
        : document.getElementsByName(`${id}`).item(0)
        ? document.getElementsByName(`${id}`).item(0).value
        : null
      if ((other_value == '' || other_value == null) && !required) required = true
    })
    const result = (target.value == '' || target.value == null) && required
    return result
  },

  /**
   * 必須処理(他のフィールドが値のどれかと一致している場合、このフィールドが存在し、かつ空でないことをバリデートします。)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_if(target, terms) {
    let required = []
    let orTerms = terms[0].split('|')
    orTerms.map((orItem) => {
      let isRequired = []
      let ifTerms = orItem.split('&')
      ifTerms.map((ifItem) => {
        const other = ifItem.split(',')
        const getValue = (name) => {
          const byId = document.getElementById(name)
          const byName = document.getElementsByName(name)
          if (byId) {
            return byId.value
          } else if (byName.length) {
            // ラジオボタンorチェックボックス
            if (byName.item(0).type === 'radio' || byName.item(0).type === 'checkbox') {
              let result = null
              byName.forEach((ele) => {
                // if (ele.checked) result = ele.value
                result = ele.checked.toString()
              })
              return result
            } else {
              return byName.item(0).value
            }
          } else {
            return null
          }
        }
        // const other_value = document.getElementById(`${other[0]}`) ? document.getElementById(`${other[0]}`).value : document.getElementsByName(`${other[0]}`).item(0) ? document.getElementsByName(`${other[0]}`).item(0).value : null;
        const other_value = getValue(other[0])
        other.shift()
        // console.log(other_value,other.includes(other_value));
        isRequired.push(other.includes(other_value))
      })
      required.push(!isRequired.includes(false))
    })
    const result = (target.value == '' || target.value == null) && required.includes(true)
    return result
  },

  /**
   * 必須処理(他のフィールドが値のどれとも一致していない場合、このフィールドが存在し、かつ空でないことをバリデートします。)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_unless(target, terms) {
    let required = []
    let unlessTerms = terms[0].split('&')
    unlessTerms.map((item) => {
      const other = item.split(',')
      const other_value = document.getElementById(`${other[0]}`)
        ? document.getElementById(`${other[0]}`).value
        : document.getElementsByName(`${other[0]}`).item(0)
        ? document.getElementsByName(`${other[0]}`).item(0).value
        : null
      other.shift()
      required.push(!other.includes(other_value))
    })
    // terms.map(item => {
    //     const other = item.split(',');
    //     const other_value = document.getElementById(`${other[0]}`) ? document.getElementById(`${other[0]}`).value : document.getElementsByName(`${other[0]}`).item(0) ? document.getElementsByName(`${other[0]}`).item(0).value : null;
    //     if((other_value === other[1] ) && required) required = false;
    // });
    const result = (target.value == '' || target.value == null) && !required.includes(false)
    return result
  },

  /**
   * 必須処理(他のフィールドが値のどれかと一致している場合と指定した他のフィールドかつ自分のどれか一つでも存在して場合、このフィールドが存在し、かつ空でないことをバリデートします。)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_if_without(target, terms) {
    const terms_split = terms[0].split('+')
    const ifTerms = [terms_split[0]]
    const withoutTerms = [terms_split[1]]
    const ifResult = validateFunc.validate_required_if(target, ifTerms)
    const withoutResult = validateFunc.validate_required_without(target, withoutTerms)
    const result = ifResult && withoutResult
    return result
  },

  /**
   * 必須処理(checkboxチェックが入っているかどうか)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_checked(target, terms) {
    const result = !target.checked
    return result
  },

  /**
   * 必須処理(radioボタンにチェックが入っているかどうか)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_radio(target, terms) {
    let required = true
    target.forEach((currentValue, currentIndex, listObj) => {
      if (currentValue.checked) required = false
    })
    return required
  },

  /**
   * 最小金額処理
   * @param {object} target
   * @param {array} terms
   */
  validate_min(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = helperNoneComma(target.value) < helperNoneComma(terms[0]) * 10000
    return result ? true : false
  },

  /**
   * 最大金額処理
   * @param {object} target
   * @param {array} terms
   */
  validate_max(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = helperNoneComma(target.value) > helperNoneComma(terms[0]) * 10000
    return result ? true : false
  },

  /**
   * 以上の比較処理
   * @param {object} target
   * @param {array} terms
   */
  validate_more(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = helperNoneComma(+target.value) < helperNoneComma(+terms[0])
    return result ? true : false
  },

  /**
   * 以下の比較処理
   * @param {object} target
   * @param {array} terms
   */
  validate_less(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = helperNoneComma(+target.value) > helperNoneComma(+terms[0])
    return result ? true : false
  },

  /**
   * 比較対象の~%までのご利用金額処理
   * @param {object} target
   * @param {array} terms
   */
  validate_percent(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    let comparison = document.getElementById(terms[1]).value
    const result = helperNoneComma(target.value) > helperNoneComma(comparison) * (terms[0] / 100)
    return result ? true : false
  },

  /**
   * 比較対象の~%までのご利用金額処理のテスト
   * @param {object} target
   * @param {array} terms
   */
  validate_percent_test(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = helperNoneComma(target.value) > helperNoneComma(terms[1]) * (terms[0] / 100)
    return result ? true : false
  },

  /**
   * 各型のより小さいバリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_lt(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    // console.log(terms);
    if (terms[1] === 'numeric') {
      const other_target = document.getElementById(terms[0])
      const result = helperNoneComma(target.value) > helperNoneComma(other_target.value)
      // console.log(helperNoneComma(target.value),helperNoneComma(other_target.value),result);
      return result
    } else {
      return false
    }
  },

  /**
   * 日本語バリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_japanese(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(
      /^([0-9])|([０-９])|([\uFF65-\uFF9F])|([!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~])|(?:[！”＃＄％＆’（）＊＋，－．／：；＜＝＞？＠［￥］＾＿‘｛｜｝￣])|([、。・゛゜´｀¨ヽヾゝゞ〃仝〆〇ー―‐＼～〜∥…‥“〔〕〈〉《》「」『』【】±×÷≠≦≧∞∴♂♀°′″℃￠￡§☆★○●◎◇◇◆□■△▲▽▼※〒→←↑↓〓])+$/g
    )
    return result ? true : false
  },

  /**
   * 文字列のバリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_string(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = typeof target.value === 'string' ? false : true
    return result
  },

  /**
   * カタカナバリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_kana(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^([ァ-ヶー])+$/g)
    return !result ? true : false
  },

  /**
   * スペース混じりのカタカナバリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_kana_with_space(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^([ァ-ヶー 　])+$/g)
    return !result ? true : false
  },

  /**
   * 文字数処理
   * @param {object} target
   * @param {array} terms
   */
  validate_maxlen(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const count = target.value.length
    const result = count > terms[0]
    return result ? true : false
  },

  /**
   * 全角処理
   * @param {object} target
   * @param {array} terms
   */
  validate_full_width(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^[^\x01-\x7E\xA1-\xDF]+$/g)
    return !result ? true : false
  },

  /**
   * 整数処理
   * @param {object} target
   * @param {array} terms
   */
  validate_integer(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    // const result = target.value.match(/^[0-9]+$/g);
    const result = isNaN(helperNoneComma(target.value))
    return result ? true : false
  },

  /**
   * 郵便番号バリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_post(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const regexp = /\d{3}[-]\d{4}/g
    // const regexp = /^[0-9\-]+$/g;
    const result = target.value.match(regexp)
    return !result ? true : false
  },

  /**
   * 住所処理
   * @param {object} target
   * @param {array} terms
   */
  validate_address(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const regexp = /(北海道|東京都|(大阪|京都)府|(神奈川|和歌山|鹿児島)県|[^\s\w\d]{2}県)[^\s\w\d　]{1,6}[市郡区町村]*/g
    const result = target.value.match(regexp)
    return !result ? true : false
  },

  /**
   * メールアドレス処理
   * @param {object} target
   * @param {array} terms
   */
  validate_email(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
    return !result ? true : false
  },

  /**
   * 電話処理
   * @param {object} target
   * @param {array} terms
   */
  validate_tel(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^\+?[\d]+-?[\d]+-?[\d]+$/)
    return !result ? true : false
  },

  /**
   * 住所カナ処理
   * @param {object} target
   * @param {array} terms
   */
  validate_address_kana(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^[ァ-ヴa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー‐‑–—―−－\s]+$/g)
    return !result ? true : false
  },

  /**
   * 会社カナ処理
   * @param {object} target
   * @param {array} terms
   */
  validate_company_kana(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = target.value.match(/^[ァ-ヴa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー‐‑–—―−－&'.,＆’，．・\s]+$/g)
    return !result ? true : false
  },

  /**
   * 単位処理(チェックが入っているかどうか)
   * @param {object} target
   * @param {array} terms
   */
  validate_unit(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const result = helperNoneComma(target.value) % terms[0] === 0
    return !result ? true : false
  },

  /**
   * 上限チェック処理
   * @param {object} target
   * @param {array} terms
   * @returns
   */
  validate_limit(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const array = terms[0].split(','),
      limit = array[0],
      type = array[1]
    let result = false
    if (type === 'upper') {
      result = target.value > limit
    } else if (type === 'lower') {
      result = target.value < limit
    }
    return result ? true : false
  },

  /**
   * 範囲チェック処理
   * @param {object} target
   * @param {array} terms
   * @returns
   */
  validate_between(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    const array = terms[0].split(','),
      min = Number(array[0]),
      max = Number(array[1]),
      unit = array[2]
    const value = Number(target.value.replace(unit, ''))
    const result = max >= value && value >= min
    return !result ? true : false
  },

  /**
   * 日付が有効かどうかのバリデーション
   * @param {object} target
   * @param {array} terms
   */
  validate_date(target, terms) {
    if (validateFunc.validate_required(target, terms)) return false
    let date
    if (terms.length) {
      let year,
        months = '12月',
        day = '2日',
        join
      const sorting = (value) => {
        if (value.match(/年/g)) {
          year = value
        } else if (value.match(/月/g)) {
          months = value
        } else if (value.match(/日/g)) {
          day = value
        }
      }
      sorting(target.value)
      terms.map((id, index) => {
        let other_date = document.getElementById(`${id}`)
          ? document.getElementById(`${id}`)
          : document.getElementsByName(`${id}`).item(0)
          ? document.getElementsByName(`${id}`).item(0)
          : null
        if (other_date) sorting(other_date.value)
      })
      if (year && months && day) join = year + months + day
      date = join.replace(/年|月/g, '/').replace(/日/g, '')
    } else {
      // 年と月しかないvalueの処理
      if (target.value.match(/年|月/g) && !target.value.match(/日/g)) {
        date = target.value.replace(/年|月/g, '/')
        date = date + '1'
      } else {
        date = target.value.replace(/年|月/g, '/').replace(/日/g, '')
      }
    }
    const result = new Date(date).getTime()
    return !result ? true : false
  },

  /**
   * カスタムバリデーション(誕生日から契約制限年齢かどうかバリデーション)
   * @param {object} target
   * @param {array} terms
   */
  validate_birthday_range(target, terms) {
    const withoutTerms = terms[0]
    if (validateFunc.validate_required_without(target, withoutTerms)) return false
    const range = terms[1].split('~')
    const values = []
    const ids = withoutTerms.split(',')
    values.push(target.value)
    ids.map((id) => {
      values.push(
        document.getElementById(`${id}`)
          ? document.getElementById(`${id}`).value
          : document.getElementsByName(`${id}`).item(0)
          ? document.getElementsByName(`${id}`).item(0).value
          : null
      )
    })
    const selectedYear = values.find((item) => item.match('年'))
      ? values.find((item) => item.match('年')).replace('年', '')
      : null
    const selectedMonth = values.find((item) => item.match('月'))
      ? values.find((item) => item.match('月')).replace('月', '')
      : null
    const selectedDay = values.find((item) => item.match('日'))
      ? values.find((item) => item.match('日')).replace('日', '')
      : null
    if (selectedYear && selectedMonth && selectedDay) {
      const age = helperGetBirthday(selectedYear, selectedMonth, selectedDay)
      const result = age < range[0] || range[1] < age
      return result
    }
    return false
  },

  /**
   * カスタムバリデーション(Eventを強制発火させメッセージをカスタマイズして表示)
   * @param {object} target
   * @param {array} terms
   */
  validate_message_custom(target, terms) {
    if (validateFunc.validate_required(target, terms)) return true
    return false
  },

  // 条件によって必須が変更(個人情報入力専用)
  /**
   * 必須処理(チェックが入っているかどうか)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_user(target, terms) {
    // 1が自社割賦＋無職/専業主婦
    // 2が自社割賦＋学生
    // 3が自社割賦
    // 4が信販＋専業主婦
    // 5が信販＋学生+世帯主が配偶者
    // 6が信販＋学生
    // 7が信販+世帯主が配偶者
    // 8が信販
    const terms_split = terms.split('?')
    const status = document.getElementById(
      '<----- ここに信販か自社割賦かのvalueを取得できるinputタグ[type=hidden]のid名を指定 ----->'
    ).value
    const householder = document.getElementById(
      '<-----  ここにお申し込みと世帯主の関係のvalueが取得できるinputタグのid名を指定  ----->'
    ).value
    const profession = document.getElementById(
      '<------ ここに職業のvalueを取得できるinputタグのid名を指定 ------>'
    ).value
    let type = 0
    // 条件tpyeを取得
    switch (profession) {
      // 無職/専業主婦
      case '<-- ここに無職のvalueを指定 -->':
        type = status === 'credit' ? 8 : 1
        break
      // 学生
      case '<-- ここに学生のvalueを指定 -->':
        if (status === 'credit') {
          type = householder === '<----- ここに世帯主が配偶者のvalueを指定 ----->' ? 5 : 6
        } else {
          type = 2
        }
        break
      // 専業主婦
      case '<-- ここに専業主婦のvalueを指定 -->':
        status === 'credit' ? 4 : 1
        break
      default:
        if (status === 'credit') {
          type = householder === '<----- ここに世帯主が配偶者のvalueを指定 ----->' ? 7 : 8
        } else {
          type = 3
        }
        break
    }
    const result = terms_split.filter((item) => item == type)
    if (result.length) {
      return validateFunc.validate_required(target.value, terms_split) ? true : false
    } else {
      return false
    }
  },
  // 条件によって必須が変更(個人情報入力専用)のテスト
  /**
   * 必須処理(チェックが入っているかどうか)
   * @param {object} target
   * @param {array} terms
   */
  validate_required_user_test(target, terms, status, householder, profession) {
    // 1が自社割賦＋無職/専業主婦
    // 2が自社割賦＋学生
    // 3が自社割賦
    // 4が信販＋専業主婦
    // 5が信販＋学生+世帯主が配偶者
    // 6が信販＋学生
    // 7が信販+世帯主が配偶者
    // 8が信販
    const terms_split = terms.split('?')
    let type = '0'
    // 条件tpyeを取得
    switch (profession) {
      // 無職
      case '0':
        type = status === 'credit' ? 8 : 1
        break
      // 学生
      case '1':
        if (status === 'credit') {
          type = householder === '0' ? 5 : 6
        } else {
          type = 2
        }
        break
      // 専業主婦
      case '2':
        type = status === 'credit' ? 4 : 1
        break
      default:
        if (status === 'credit') {
          type = householder === '0' ? 7 : 8
        } else {
          type = 3
        }
        break
    }
    const result = terms_split.filter((item) => item == type)
    if (result.length) {
      return validateFunc.validate_required(target.value, terms_split) ? true : false
    } else {
      return false
    }
  },
  /**
   * 余り計算
   * @param {object} target
   * @param {array} terms
   * /payment,ボーナス2回払い:total_pay:payment_amount_second
   */
  validate_calc_remainder(target, terms) {
    const one = helperNoneComma(target.value)
    const paymentLogic = terms[0].split(',')
    const payment = document.getElementById(paymentLogic[0]).value
    if (payment !== paymentLogic[1]) {
      return
    }
    const totalPay = helperNoneComma(document.getElementById(terms[1]).innerText)
    const paymentAmountSecond = parseInt(document.getElementById(terms[2]).value)
    return one !== totalPay - paymentAmountSecond
  }
}

/**
 * バリデーションメッセージ削除
 * @param {string} error_add エラーメッセージを追加するid名
 * @param {string} error_rule エラーメッセージのルール名
 * @param {string} rule バリデーションのルール名
 * @param {boolean} error_header ヘッダにエラーを表示するか否か
 */
export const removeError = (error_add, error_rule, error_header) => {
  // メッセージ削除
  const removes = Array.from(document.getElementsByClassName(`error-${error_add}-${error_rule}`))
  if (removes.length) {
    removes.map((item) => {
      item.innerHTML = ''
      // 項目名部分にclass名を追加
      if (error_header) {
        const header = item.closest('.js_error').querySelector('.js_error_header')
        header.classList.remove(`is_active_${error_add}_${error_rule}`)
      }
    })
  }
  // const removeHeader = document.getElementsByClassName(`error-${error_add}-${error_rule}`);
  // if(removeHeader.length) {
  //     // 項目名部分のclass名を追加
  //     removeHeader.map(item => {
  //         item.classList.remove(`error-${error_add}-${error_rule}`);
  //     });
  // }
}

/**
 * バリデーションメッセージ追加
 * @param {string} error_add エラーメッセージを追加するid名
 * @param {string} error_rule エラーメッセージのルール名
 * @param {string} rule バリデーションのルール名
 * @param {array} terms バリデーションの条件
 */
const setError = (error_add, error_rule, rule, terms, action, error_header, message) => {
  // メッセージ追加
  const adds = Array.from(document.getElementsByClassName(`error-${error_add}-${error_rule}`))
  if (adds.length) {
    adds.map((item) => {
      item.innerHTML = message ? message : validateMessage[rule](ValidationText[error_add], action, terms)
      // 項目名部分にclass名を追加
      if (error_header) {
        const header = item.closest('.js_error').querySelector('.js_error_header')
        header.classList.add(`is_active_${error_add}_${error_rule}`)
      }
    })
  }
}

export const setErrorLaravel = (error_add, rule, message, error_header) => {
  // メッセージ追加
  const exception = {
    bonus_combined_month1: 'bonus_combined_month',
    bonus_combined_month2: 'bonus_combined_month',
    surname: 'name',
    first_name: 'name',
    surname_kana: 'name_kana',
    first_name_kana: 'name_kana',
    // 'street_address1': 'street_address',
    // 'street_address2': 'street_address',
    // 'street_address3': 'street_address',
    fixed_phone1: 'fixed_phone',
    fixed_phone2: 'fixed_phone',
    fixed_phone3: 'fixed_phone',
    mobile_phone1: 'mobile_phone',
    mobile_phone2: 'mobile_phone',
    mobile_phone3: 'mobile_phone',
    // 'parents_address1': 'parents_address',
    // 'parents_address2': 'parents_address',
    parents_phone1: 'parents_phone',
    parents_phone2: 'parents_phone',
    parents_phone3: 'parents_phone',
    parents_mobile_phone1: 'parents_phone',
    parents_mobile_phone2: 'parents_phone',
    parents_mobile_phone3: 'parents_phone',
    company_phone1: 'company_phone',
    company_phone2: 'company_phone',
    company_phone3: 'company_phone',
    // 'company_address1': 'company_address',
    // 'company_address2': 'company_address',
    join_year: 'join',
    join_month: 'join'
  }
  const className = exception[error_add] || error_add
  // console.log(`error-${className}-${rule}`)
  const adds = Array.from(document.getElementsByClassName(`error-${className}-${rule}`))
  if (adds.length) {
    adds.map((item) => {
      item.innerHTML = message

      // 項目名部分にclass名を追加
      if (error_header) {
        const header = item.closest('.js_error').querySelector('.js_error_header')
        header.classList.add(`is_active_${className}_${rule}`)
      }
    })
  }
}
